module.exports = __webpack_public_path__ + "static/graphic-aapacn-cf7acabf277036643bafddbeff8d78cc.svg";